<template>
  <div>
    <div class="mainContent">
      <div>
        <div v-if="state === 'success'" class="backg successBg"></div>
        <div v-else-if="state === 'expired'" class="backg wrongBg"></div>
        <div v-else-if="state === 'invalid'" class="backg wrongBg"></div>
        <div v-else-if="state === 'failed'" class="backg failedBg"></div>
        <div class="content">
          <UrlCheckView />
          <NavBar />
          <SuccessView
            :roundId="rid"
            :timestamp="t"
            :tranId="tid"
            :env="env"
            v-if="state === 'success'"
          />
          <SessionExpiredView v-else-if="state === 'expired'" />
          <FailedView v-else-if="state === 'failed'" />
          <InvalidView v-else-if="state === 'invalid'" />
          <LoaderView v-else-if="state === 'loading'" />
          <div
            v-if="state === 'success' || state === 'invalid'"
            class="version bar"
          >
            1.0.9.1
          </div>
          <div v-else class="version bar">1.0.9.1</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import FailedView from "@/components/FailedView.vue";
import SuccessView from "@/components/SuccessView.vue";
import SessionExpiredView from "@/components/SessionExpiredView.vue";
import axios from "axios";
import InvalidView from "@/components/InvalidView.vue";
import LoaderView from "@/components/LoaderView.vue";
import UrlCheckView from "./UrlCheckView.vue";

export default {
  name: "VerifyPG",
  components: {
    LoaderView,
    InvalidView,
    SessionExpiredView,
    SuccessView,
    FailedView,
    NavBar,
    UrlCheckView,
  },
  data() {
    return {
      l: "en",
      rid: "",
      tid: "",
      t: "",
      env: "",
      state: "loading",
    };
  },
  mounted() {
    // Parse query parameters using URLSearchParams
    const urlParams = new URLSearchParams(window.location.search);
    const l = urlParams.get("l");
    const rid = urlParams.get("rid");
    const tid = urlParams.get("tid");
    const t = urlParams.get("t");
    const env = urlParams.get("env");

    // Set the data properties if query params are available
    if (l) {
      this.l = l;
    }
    if (rid) {
      this.rid = rid;
    }
    if (tid) {
      this.tid = tid;
    }
    if (t) {
      this.t = t;
    }
    if (env) {
      this.env = env;
    }
    if (l && rid && env && t) {
      this.verifyTransaction();
      this.$i18n.locale = ["ar", "fa"].includes(l) ? "en" : l;
    } else {
      this.state = "expired";
    }
  },
  methods: {
    verifyTransaction(retryCount = 0) {
      const url =
        this.env === "1"
          ? "https://api.pgf-asw0zzz.com/game/result"
          : "https://api.pgs-demo.com/game/result";
      axios
        .post(url, {
          roundId: this.rid,
          timestamp: this.t,
        })
        .then((res) => {
          if (res.data.status.code === 0) {
            this.state = "success";
          } else if (
            (res.data.status.code === 999 || res.data.status.code === 500) &&
            retryCount < 5
          ) {
            setTimeout(() => this.verifyTransaction(retryCount + 1), 2000);
          } else {
            this.state = "failed";
          }
        })
        .catch((err) => {
          const code = err.response?.data?.status?.code;
          if ((code === 999 || code === 500) && retryCount < 5) {
            setTimeout(() => this.verifyTransaction(retryCount + 1), 2000);
          } else {
            this.state = "expired";
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
